import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { Fragment } from 'react/jsx-runtime';

type EditableDocumentListProps<T extends Model.IDocument> = {
  data: T[];
  onUpdate: (index: number, value: Partial<Model.IDocument>) => void;
  onDelete: (index: number) => void;
};

const EditableDocumentList = <T extends Model.IDocument>({
  data,
  onUpdate,
  onDelete,
}: EditableDocumentListProps<T>) => {
  const { lang } = getLocales();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: Theme.Size.L }}>
      <DataMap
        data={data}
        render={({ data: item, index }) => (
          <Fragment key={index}>
            <InputWrapper>
              <TextInput
                name="name"
                label={lang.name}
                value={item?.name}
                error={!item?.name && lang.required}
                onChange={({ name }) => onUpdate(index, { name })}
              />
              <TextInput
                name="notes"
                label={lang.notes}
                value={item?.notes}
                onChange={({ notes }) => onUpdate(index, { notes })}
              />
              <Button
                class={ThemeButtonCircle}
                htmlElementProps={{ title: lang.delete }}
                onClick={() => onDelete(index)}
                media={<Icon class="fas-trash" />}
              />
            </InputWrapper>
          </Fragment>
        )}
      />
    </div>
  );
};

export default EditableDocumentList;
